module.exports = __webpack_public_path__ + "img/Misterio y suspenso.e65cce42.svg";